import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';

/*Actions*/
import {
	addToList,
	saveToList,
	getOrderDetailsList,
	saveOrderDetailsList,
	getSearchKeywordSuggestionList,
	ajaxRequestInitiated,
	ajaxRequestCompleted
} from '../../../redux/actions';

import { DATE_TIME_FORMAT } from '../../common/messageConstants';

class AddToList extends Component {

	constructor(props) {
        super(props);
        this.state = {
            isSpecpage: false
        };
		this.makeServiceCallAddtoList = this.makeServiceCallAddtoList.bind(this);
    }

    handleAddToList(product, productDescription, itemType, event){
	    event.preventDefault();
		const self = this,
			{ selectedAccount, selectedPriceSource } = self.props.state.user,
			{ list } = self.props.state.list,
			wishlistItems = list && list.responseObject && list.responseObject.wishlistItems ? list.responseObject.wishlistItems : [];
			let searchKeywordState = self.props.state.searchKeyword;
			let filteredProduct =[];
			if(self.props.searchSuggestions === undefined && self.props.state.product.productResultAvailability && window.location.pathname !== "/cart"){
			 filteredProduct =self.props.state.product.productResultAvailability.filter((item)=>{
				return item.sku == product
			});
			}
			if(self.props.searchSuggestions === undefined && window.location.pathname == "/cart" && self.props.state.cart.cart.responseObject.cartItems){
				filteredProduct = self.props.state.cart.cart.responseObject.cartItems.filter((item)=>{
					return item.item == product
				})
			}
			if(self.props.searchSuggestions === `searchSuggestions`){
				filteredProduct= searchKeywordState && searchKeywordState.productNumberList && searchKeywordState.productNumberList.length > 0 && searchKeywordState.productNumberList.filter((item)=>{
					return item.sku == product
				})
			}

		self.props.fireGTMTag('Add to List', {
			prodSku: product
		});

		if(self.props.isPackage) {
			// get packges details
			self.props.getOrderDetailsList(`orderNumber=${self.props.orderNumber}&requestType=getOrderDetails&accountNumber=${selectedAccount.ACCOUNTNUMBER}`, (response) => {
				if(!response.status) { // if data is not found
					self.props.saveOrderDetailsList(null);
				} else {
					self.props.getItemTypeByOrderDetails(response.responseObject, resp => {
						if(!resp.status) {
							self.setState({
								errorMessage: response.responseMessage
							})
						} else {
							const orderDetails = resp.orderDetails;
							let count= 0;
							self.props.ajaxRequestInitiated();
							let keys=[];
							orderDetails.items.forEach((item,index) => {
								keys.push(item.item);
								const createdDate = moment().add(index,'seconds').format(DATE_TIME_FORMAT);
								self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${item.item}&count=5`, (response) => {
								item.imagePath = response.responseObject.length>0 ? response.responseObject[0].imagePath:"";
			                    wishlistItems.push ({
			       				    itemType: item.itemType,
			       				    item: item.item,
			       				    quantity: "1",
			       				    itemDescription: item.itemDescription,
			                        packageName: self.props.packageName,
			                        parentItem: null,
									agreementNumber: item.agreementNumber,
									createdDate: createdDate,
									updatedDate: moment().format(DATE_TIME_FORMAT),
									imagePath:item.imagePath,
									overpackQuantityRequired: item.overpackQuantityRequired,
									packageQuantity: item.packageQuantity
			       		        });
								count++;
								if(count === orderDetails.items.length){ 
									self.props.ajaxRequestCompleted();
									self.makeServiceCallAddtoList(wishlistItems,keys);
								};								
							});
						})
					}});
				}
			});
		} else {
			wishlistItems.push({
	            itemType: !itemType || itemType === ''  ? "M" : itemType,
	            item: product,
	            quantity: 1,
	            itemDescription: productDescription,
				agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
				createdDate: moment().format(DATE_TIME_FORMAT),
				updatedDate: moment().format(DATE_TIME_FORMAT),
				imagePath:filteredProduct && filteredProduct.length>0 ? filteredProduct[0].imagePath:"",
				overpackQuantityRequired: filteredProduct && filteredProduct.length>0 ? filteredProduct[0].overpackQuantityRequired:"",
				packageQuantity: filteredProduct && filteredProduct.length>0 ? filteredProduct[0].packageQuantity:""
	        });
			self.makeServiceCallAddtoList(wishlistItems);
		}
    }

	makeServiceCallAddtoList(wishlistItems,products=[]) {
		const self = this,
			{ selectedAccount, userDetails } = self.props.state.user;
			if (products.length>0){
				//Sort wishlistItems based on the products array
				wishlistItems.sort(function (a, b) {
					return products.indexOf(a.item) - products.indexOf(b.item);
				  });
			};
		self.props.addToList({
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			wishlistItems: wishlistItems
		}, response => {
			if(response.status && response.responseObject) {
				const skuList = [];
				response.responseObject && response.responseObject.wishlistItems && response.responseObject.wishlistItems.length > 0 && response.responseObject.wishlistItems.map((item, index) => {
					if(item.itemType === 'M' || item.itemType === 'A')
						skuList.push({"sku":item.item})
					return null;
				})
				if(window.location.pathname.indexOf('list') !== -1) {
					const data = JSON.parse(self.props.state.user.selectedAddress);
					const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
					zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
						if(resp && resp.agentid) {
							self.props.checkAvailabilityGeneric(skuList, `accountNumber=${selectedAccount.ACCOUNTNUMBER}&zipCode=${self.props.getZipCode()}&legacyCustCode=${self.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, 'list', true, response => {
							});
						}
					});
				}
				response.responseObject.wishlistItems.map(item =>{
					wishlistItems.map(itm => {
						if(itm.item == item.item){
							item["overpackQuantityRequired"]=itm.overpackQuantityRequired;
							item["packageQuantity"]=itm.packageQuantity;
						}
				})
				});
				self.props.saveToList(response);
			} else {
				browserHistory.push('/error');
			}
		});
	}

    render() {
		const isPunchOutAccess = (localStorage.getItem("punchOutAccess") == true || localStorage.getItem("punchOutAccess") == 'true')
        const { list } = this.props.state.list;
        const wishlistItems = list && list.responseObject && list.responseObject.wishlistItems?list.responseObject.wishlistItems:null;
        let skuList = wishlistItems && wishlistItems.map(item => {
			return item.item;
		});
		skuList = skuList ? skuList : [];
		const itemContains = skuList.indexOf(this.props.item) !== -1 ? true : false;
        return (
			!isPunchOutAccess && 
            <div>
				{this.props.isTypeAhead
					?<div className="specPageCustomerNetSpecial">
	                    {skuList!==null
							?<div className="leftSide">
		                        {itemContains?
		    				        <p className="addToListLinkParagraph">
		    					        <a className="addToListLink" href="" style={{width: '34%'}} onClick={this.handleAddToList.bind(this, this.props.item, this.props.itemDescription,this.props.itemType)}>+ <u>Add to List</u></a>
		    				        </p>:
		    				        <p className="addedToListParagraph">
		    					        ✓ Added to List
		    				        </p>}
		    			    </div>
							:null
						}
                	</div>
					:<div>
		                {itemContains
							?<p className="addProductBtn"><span id={"wishListItem_"+this.props.item}>&#x2713; In List</span></p>
							:<p className="addProductBtn"><span id={"wishListItem_"+this.props.item}><a className="addToListLink" href="" onClick={this.handleAddToList.bind(this, this.props.item, this.props.itemDescription,this.props.itemType)}>+ <u>Add to List</u></a></span></p>
						}
	                </div>
				}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	addToList: (payload, callback) => dispatch(addToList(payload, callback)),
	saveToList: (data) => dispatch(saveToList(data)),
	getOrderDetailsList: (queryStringParams, callback) => dispatch(getOrderDetailsList(queryStringParams, callback)),
	saveOrderDetailsList: (orderDetailsList) => dispatch(saveOrderDetailsList(orderDetailsList)),
	getSearchKeywordSuggestionList: (payload, callback) => dispatch(getSearchKeywordSuggestionList(payload, callback)),
	ajaxRequestInitiated: (data) => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: (data) => dispatch(ajaxRequestCompleted(data)),
});

AddToList = connect(mapStateToProps, mapDispatchToProps)(AddToList);
export default AddToList;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/common/AddToList.js